<div class="lock-header"
     [ngClass]="{'animation': isDesktop}">
  <span class="back-button-container">
    <ion-button fill="clear" class="back-button" (click)="onBackClick()">
      <i class="fas fa-arrow-circle-left icon"></i>
    </ion-button>
  </span>
</div>

<div class="full-content">
  <router-outlet></router-outlet>
</div>
